module.exports = __webpack_public_path__ + "img/logo.23bea2b8.png";